import { Component, OnInit } from '@angular/core';
import { TRACK_APP } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-track-app-error',
  templateUrl: './track-app-error.component.html',
  styleUrls: ['./track-app-error.component.scss']
})
export class TrackAppErrorComponent implements OnInit {
  track_app: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  constructor(private themeService: ThemeService) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.track_app = TRACK_APP;
  }

}